<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

// Composables
const { t } = useI18n()

// Props
const props = defineProps({
  event: {
    type: Object,
    required: true
  }
})

// Computed
const hasOdds = computed(() => {
  return props.event.odds && props.event.odds.length > 0
})

const odds = computed(() => {
  if (!hasOdds.value) return []
  // Return only odds with odd.market_key = 'h2h'
  return props.event.odds.filter(odd => odd.market_key === 'h2h')
})

</script>

<template>
  <div v-if="hasOdds">
    <!-- Best Odds Display -->
    <div class="best-odds-container">
      <div v-for="odd in odds" class="mb-4">
        <div class="text-center my-1">
          {{ $t(`events.betting.betTypes.${odd.market_key}`) }}
        </div>
        <div class="odds-values">
          <div v-for="(outcome, index) in odd.outcomes" class="odd-item">
            <span class="odd-label">{{ outcome.name }}</span>
            <v-chip 
              color="success" 
              size="small"
              :text="outcome.price"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- No Odds Available -->
  <div v-else class="no-odds">
    <v-icon color="grey">mdi-information-outline</v-icon>
    <span class="text-caption text-grey ml-2">{{ t('events.odds.notAvailable') }}</span>
  </div>
</template>

<style scoped>
.best-odds-container {
  background: #2b2b2b;
  border-radius: 8px;
  padding: 12px;
}

.odds-row:last-child {
  margin-bottom: 0;
}

.odds-values {
  display: flex;
  gap: 18px;
  align-items: center;
  width: 100%;
  justify-content: center;
}

.odd-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 50px;
}

.odd-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #666;
}

.no-odds {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 8px;
}
</style>